
import React from 'react';
import Button from '../../../components/base/Button';

const ServicesSection: React.FC = () => {
  const mainServices = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Isenção de Imposto de Renda para Doenças Graves',
      description: 'Aposentados e pensionistas com câncer, HIV, AVC e outras doenças graves. Processo INSS e servidores públicos.',
      features: ['Análise de enquadramento legal', 'Orientação sobre laudos e documentos', 'Protocolo e acompanhamento do pedido'],
      highlight: true
    },
    {
      icon: 'ri-heart-line',
      title: 'Pensão por Morte',
      description: 'Orientação jurídica completa para a família em momentos difíceis.',
      features: ['Orientação familiar', 'Documentação necessária', 'Acompanhamento contínuo do andamento']
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Aposentadorias',
      description: 'Tempo de contribuição, especial, por idade, híbrida (tempo rural + tempo urbano), professor e PCD.',
      features: ['Planejamento conforme regras vigentes', 'Cálculo e análise de tempo/contribuições', 'Verificação de requisitos e documentos']
    },
    {
      icon: 'ri-shield-user-line',
      title: 'BPC/LOAS',
      description: 'Benefício para idosos 65+ ou pessoas com deficiência, renda até 1 salário mínimo por pessoa.',
      features: ['Análise de renda familiar e requisitos', 'Orientação sobre laudos e cadastros', 'Acompanhamento do processo administrativo']
    },
    {
      icon: 'ri-refresh-line',
      title: 'Revisão de Benefícios',
      description: 'Análise técnica especializada para aumento retroativo de benefícios.',
      features: ['Revisão completa', 'Cálculo de diferenças', 'Verificação de diferenças e eventuais valores retroativos']
    },
    {
      icon: 'ri-file-list-line',
      title: 'Outros Serviços',
      description: 'Planejamento Previdenciário, Auxílio-reclusão, Inventário e mais.',
      features: ['Consultoria especializada', 'Planejamento futuro', 'Assessoria completa']
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#214134] mb-6">
            Nossos Serviços Especializados
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Oferecemos soluções completas em Direito Previdenciário com foco em resultados 
            e atendimento humanizado para cada situação específica.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mainServices.map((service, index) => (
            <div 
              key={index}
              className={`bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 ${
                service.highlight ? 'ring-2 ring-[#cc9b3f] transform hover:scale-105' : 'hover:transform hover:scale-105'
              }`}
            >
              {service.highlight && (
                <div className="bg-[#cc9b3f] text-white text-sm font-semibold px-3 py-1 rounded-full inline-block mb-4">
                  Mais Procurado
                </div>
              )}
              
              <div className="w-16 h-16 bg-[#214134] rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-[#cc9b3f]`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-[#214134] mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              
              <ul className="space-y-2 mb-6">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center space-x-2">
                    <div className="w-4 h-4 bg-[#cc9b3f] rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-xs text-white"></i>
                    </div>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Button 
                href={`https://wa.me/5544988019071?text=Olá! Gostaria de saber mais sobre o serviço: ${service.title}`}
                target="_blank"
                variant="outline"
                className="w-full"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Consultar Agora
              </Button>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-[#214134] rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Não encontrou o que procura?
          </h3>
          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
            Oferecemos consultoria personalizada para casos específicos. 
            Entre em contato e vamos analisar sua situação.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              href="https://wa.me/5544988019071?text=Olá! Preciso de uma consultoria personalizada sobre direito previdenciário."
              target="_blank"
              size="lg"
            >
              <i className="ri-whatsapp-line mr-3"></i>
              Consultoria Personalizada
            </Button>
            <Button 
              variant="outline"
              size="lg"
              className="border-white text-white hover:bg-white hover:text-[#214134]"
              onClick={() => {
                const element = document.getElementById('contato');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <i className="ri-mail-line mr-3"></i>
              Enviar Mensagem
            </Button>
          </div>
        </div>

        {/* Nota Informativa */}
        <div className="mt-8 text-center">
          <p className="text-gray-600 text-sm max-w-3xl mx-auto">
            Cada caso é único; prazos e desfechos variam conforme a legislação, as provas e os órgãos competentes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
